import {createApp} from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
//引入ElementPlus
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
// 统一导入el-icon图标
import * as ElIconModules from '@element-plus/icons'
// 引入i18n国际化
import i18n from './i18n'

// 引入公用的js
import $, {transElIconName} from './assets/js/js.js'

// 引入公用的样式文件
import './assets/css/reset.css';
import './assets/css/main.css';
import './assets/css/anim.scss';
import './assets/css/page.scss';
// 兼容IE   开始
import '@babel/polyfill'
import Es6Promise from 'es6-promise';
// 兼容IE   结束
// px2rem 自适应
import './assets/js/lib-flexible/flexible.js'
//手机端控制台
// import vConsole from './http/vconsole'
import {dragscrollNext} from 'vue-dragscroll'
// 网络请求
import {
  deleteFormRequest,
  deleteRequest,
  getRequest,
  postFormRequest,
  postRequest,
  putFormRequest,
  putRequest,
  uploadFileAli,
  uploadFileQiNiu,
  uploadFileRequest,
} from './http/http.js'
import Bus from './assets/js/bus.js' /// mitt 总线程引入

require('es6-promise').polyfill()
Es6Promise.polyfill();


// 路由拦截判断
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    $.title(to.meta.title);
  }
  next();
})

// 路由切换完成后执行
router.afterEach((to, from) => {
  // 只在路由页面切换时滚动到顶部（不包括同页面内的查询参数变化）
  const isRouteChanged = to.name != from.name

  if (isRouteChanged) {
    // 使用 nextTick 确保 DOM 更新后再滚动
    setTimeout(() => {
      // 多种方式确保滚动生效
      window.scrollTo(0, 0);
      window.scrollTo({top: 0, behavior: 'instant'});
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 0);
  }
  // 注意：同页面内的查询参数变化（如分类切换）由各页面自己处理滚动行为
})

const app = createApp(App)

let banIcon = ['Filter', 'Link', 'Menu', 'Picture', 'Select', 'Switch', 'View']
// 统一注册el-icon图标
for (let iconName in ElIconModules) {
  if (banIcon.indexOf(iconName) === -1) {
    app.component(transElIconName(iconName), ElIconModules[iconName])
  }
}

app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
})
app.use(i18n)
app.directive('dragscroll', dragscrollNext);

app.config.globalProperties.$axios = axios
app.config.globalProperties.$baseUrl = axios.defaults.baseURL
app.config.globalProperties.$method = $
app.config.globalProperties.$get = getRequest
app.config.globalProperties.$post = postRequest
app.config.globalProperties.$delete = deleteRequest
app.config.globalProperties.$deleteForm = deleteFormRequest
app.config.globalProperties.$put = putRequest
app.config.globalProperties.$putForm = putFormRequest
app.config.globalProperties.$uploadFile = uploadFileRequest
app.config.globalProperties.$uploadFileQiNiu = uploadFileQiNiu
app.config.globalProperties.$uploadFileAli = uploadFileAli
app.config.globalProperties.$postForm = postFormRequest
app.config.globalProperties.bus = Bus
app.config.globalProperties.$store = store

app.mount('#app')
